import { Grid, Stack, styled, Typography } from '@mui/material';

interface BenefitDetailsPaperProgressStatusStyledProps {
  $isComplete: boolean;
}

export const BenefitDetailsDescriptionStyled = styled('p')(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(7),
}));

export const BenefitDetailsCardGridStyled = styled(Grid)({
  paddingLeft: '0 !important',
});

export const BenefitDetailsPaperStyled = styled('button')(({ theme }) => ({
  boxSizing: 'inherit',
  backgroundColor: 'white',
  whiteSpace: 'inherit',
  textAlign: 'left',
  borderRadius: '4px',
  height: '25rem',
  margin: '12px 24px 12px 0px',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    height: '30rem',
  },
}));

export const BenefitDetailsCardDesignStyled = styled('div')({
  position: 'absolute',
  top: '0',
  left: '0',
});

export const BenefitDetailsCardContentStyled = styled('div')({
  padding: '0rem 4rem 0 4rem',
});

export const BenefitDetailsCardDesignIconStyled = styled('div')({
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  color: '#000',
});

export const BenefitDetailsPaperLabelStyled = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const BenefitDetailsPaperProgressStatusStyled = styled(
  Stack
)<BenefitDetailsPaperProgressStatusStyledProps>(({ $isComplete }) => ({
  position: 'absolute',
  bottom: '2rem',
  color: $isComplete ? '#2A7527' : 'auto',
  alignItems: 'center',
}));
export const BenefitDetailsPaperProgressReqStatusStyled = styled(Stack)({
  position: 'absolute',
  bottom: '2rem',
  right: '51px',
});

export const BenefitDetailsCardRequiredTextStyled = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.error.main,
  })
);
